import { combineReducers } from "redux";
import homeSlice from "./homeSlice";
import commodity from "./tabs";
import location from "./locationTabs";
import vendorType from "./dropdownSlice";
import purchaseRequest from "./purchaseRequestTabs";
import reports from "./reportsTab";
import authorizedPersonSlice from "./commodityDeposit";
import dataSlice from "./grainManager";
import release from "./releaseTabs";
import  poDataSlice  from "./poDataSlice";
import loadingSlice from "./loadingSlice";
import thirdPartySlice from "./thirdPartySlice";

export const reducers = combineReducers({
  home: homeSlice,
  commodityTabs: commodity,
  locationTabs: location,
  vendorType: vendorType,
  purchaseRequestTabs: purchaseRequest,
  reportTabs: reports,
  authorizedPerson: authorizedPersonSlice,
  releaseTabs: release,
  data: dataSlice,
  poData : poDataSlice,
  loader : loadingSlice,
  thirdParty: thirdPartySlice,
});
